import React, { useState } from 'react';
import { useSpreadsheetStore } from './store/spreadsheetStore';
import { Add, Close } from '@mui/icons-material';
import './SheetTabs.css';

const SheetTabs = () => {
  const {
    sheets,
    activeSheetIndex,
    setActiveSheet,
    addSheet,
    renameSheet,
    deleteSheet
  } = useSpreadsheetStore();

  const [editingTab, setEditingTab] = useState(null);
  const [editingName, setEditingName] = useState('');

  const handleTabClick = (index) => {
    setActiveSheet(index);
  };

  const handleAddSheet = () => {
    addSheet();
  };

  const handleTabDoubleClick = (index, name) => {
    setEditingTab(index);
    setEditingName(name);
  };

  const handleTabNameChange = (e) => {
    setEditingName(e.target.value);
  };

  const handleTabNameKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (editingName.trim()) {
        renameSheet(editingTab, editingName.trim());
      }
      setEditingTab(null);
    } else if (e.key === 'Escape') {
      setEditingTab(null);
    }
  };

  const handleTabNameBlur = () => {
    if (editingName.trim()) {
      renameSheet(editingTab, editingName.trim());
    }
    setEditingTab(null);
  };

  const handleDeleteSheet = (index) => {
    if (window.confirm(`"${sheets[index].name}" sayfasını silmek istediğinizden emin misiniz?`)) {
      deleteSheet(index);
    }
  };

  return (
    <div className="sheet-tabs">
      <div className="sheet-tabs-container">
        {sheets.map((sheet, index) => (
          <div
            key={sheet.id}
            className={`sheet-tab ${index === activeSheetIndex ? 'active' : ''}`}
            onClick={() => handleTabClick(index)}
            onDoubleClick={() => handleTabDoubleClick(index, sheet.name)}
          >
            {editingTab === index ? (
              <input
                type="text"
                value={editingName}
                onChange={handleTabNameChange}
                onKeyDown={handleTabNameKeyDown}
                onBlur={handleTabNameBlur}
                className="sheet-tab-edit-input"
                autoFocus
              />
            ) : (
              <span className="sheet-tab-name">{sheet.name}</span>
            )}
            
            {sheets.length > 1 && (
              <button
                className="sheet-tab-close"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteSheet(index);
                }}
                title="Sayfayı Sil"
              >
                <Close fontSize="small" />
              </button>
            )}
          </div>
        ))}
      </div>
      
      <button
        className="add-sheet-button"
        onClick={handleAddSheet}
        title="Yeni Sayfa Ekle"
      >
        <Add fontSize="small" />
      </button>
    </div>
  );
};

export default SheetTabs;


